/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AssessmentType {
    ALL = 'All',
    BASKETBALL = 'Basketball',
    SOCCER = 'Soccer',
    BASEBALL = 'Baseball',
}